<template>
  <div style="background: #f0f0f0;" v-if="body_show">
    <public-top-tips v-show="data.uid && data.uid < 0"></public-top-tips>

    <div class="cep61_top">
      <h1>{{data.headtitle}}</h1>
      <h2>测试者：{{data.nickname}}</h2>
      <h3>{{data.ctime}}</h3>
      <a @click="reset" v-if="data.past_days>=90">重新测试</a>
      <a v-else style="background-color:#ccc">{{90-data.past_days}} 天后可重测</a>
      <img class="logo" src="@a/ceping90/logo.png">
    </div>
    <div class="cep61_main">
      <h1>测评结果概览 <!-- <img src="@a/cep61_2.png"> -->
      </h1>
      <h2 class="cep61_mh2">您的霍兰德代码</h2>
      <div class="cep61_list clearfix">
        <ul>
          <li v-for="(item,index) in data.total_result_top" :key="index">
            <h2>{{item.division}}</h2>
            <h3 v-if="item.text">
              <span claa="fw" v-for="(itm,idx) in item.text.split('、')" :key="idx">{{itm}}</span>
            </h3>
          </li>
        </ul>
      </div>
      <h2 class="cep61_mh2">您的得分图</h2>
      <div class="dimension_bg">
        <div id="dimension" class="dimension"></div>
      </div>
    </div>
    <div class="cep61_main">
      <h1>职业倾向性得分详情</h1>
      <p class="cep61_mp">以下是您在感兴趣的活动（兴趣）、所擅长的活动（能力）、所喜爱的职业（回报）三个方面的详细得分及总分情况：</p>
      <div class="cep61_list2">
        <table class="inclination" width="100%" cellspacing="2" cellpadding="0">
          <thead>
            <tr>
              <th>霍兰德代码</th>
              <th>兴趣</th>
              <th>能力</th>
              <th>回报</th>
              <th>总分</th>
            </tr>
          </thead>
          <tbody>
            <!--  -->
            <tr v-for="(item,index) in inclination_list" :key="index" >
              <td>{{item.division+'('+item.title+')'}}</td>
              <td>{{data.interest_result[item.division].score}}</td>
              <td>{{data.capability_result[item.division].score}}</td>
              <td>{{data.repay_result[item.division].score}}</td>
              <td>{{item.score}}</td>
            </tr>
          </tbody>
        </table>
        <!--  -->
        <div class="ins-text">
          <h5>感兴趣的活动（兴趣）</h5>
          <p>指的是你对该代码类型相关职业活动的兴趣程度。</p>
        </div>
        <div class="ins-text">
          <h5>所擅长的活动（能力）</h5>
          <p>指的是你对自身在职业代码相关活动上的能力水平的评估。</p>
        </div>
        <div class="ins-text">
          <h5>所喜爱的职业（回报）</h5>
          <p>指的是你对该代码相关职业的偏好程度。</p>
        </div>
        <div class="ins-text">
          <h5>总分</h5>
          <p>是以上三个方面的综合，综合反映了你对各个代码主题的兴趣水平。</p>
        </div>

      </div>
    </div>
    <div class="cep61_main">
      <h1>详细解析</h1>
      <h2 class="cep61_mh2">活动兴趣</h2>
      <h6>在兴趣维度上，你的前三代码排序是<div v-for="(item,index) in data.interest_result_top" :key="index">{{item.division}}</div></h6>
      <div class="js">
        <div v-for="(item,index) in data.interest_result_top" :key="index" ><span class="cle"></span><span class="text">{{item.text}}</span></div>
      </div>
      <!--  -->
      <h2 class="cep61_mh2">职业潜能</h2>
      <h6>在能力维度上，你的前三代码排序是<div v-for="(item,index) in data.capability_result_top" :key="index">{{item.division}}</div></h6>
      <div class="js">
        <div v-for="(item,index) in data.capability_result_top" :key="index" ><span class="cle"></span><span class="text">{{item.text}}</span></div>
      </div>
      <!--  -->
      <h2 class="cep61_mh2">所爱职业</h2>
      <h6>在回报维度上，你的前三代码是<div v-for="(item,index) in data.repay_result_top" :key="index">{{item.division}}</div></h6>
      <div class="small">
        <div class="stitle">你在工作回报方面的需求是：</div>
        <div class="text" v-for="(item,index) in data.repay_result_top" :key="index" >{{item.text}}</div>
      </div>
      <div class="cep61_bt">
        <h2></h2>
        <div class="cep61_btv">
          个人职业发展是一个不断变化的动态过程，随着阅历、知识、周围环境等的变化而变化，没有任何一款工具能够给你一个职业定位的最优解和最佳发展路径。<br/>
          <br/> 了解自己的兴趣倾向，是想在未来的工作中找到最适合自己的职业，鉴于现实中因为资源和条件的限制，可能此时从事的职业未必是最适合，但是也比较符合自己兴趣的工作。不过每个人也是可以给职业增添建构的能动性的，也就是说，你完全可能在任何工作中去充分发挥和创造职业的新内涵。
        </div>
      </div>
    </div>
    <!--  -->
    <p class="copynig">*本测评由新精英生涯（北京）教育科技有限公司版权所有，违者必究。</p>
    <!-- 关注二维码 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="isShow">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p>长按识别关注公众号“立即查看”</p>
        <div class="text-center">
          <img class="qr-box" :src="qrcode" alt="" />
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { ceping90_report, ceping90_reset} from "@/api/measurement";
import { shareCon} from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";
import { getSortArr} from "@/utils/tools";
import { Dialog} from 'vant';

import PublicAdQrcode from "@c/measurement/public-ad-qrcode";
import PublicTopTips from "@c/measurement/public-top-tips";

export default {
  data() {
      return {
        body_show: false,
        data: {},
        isShow: false,
        qrcode: '',
        fl_group: [],
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: "",
          nickname: ""
        },
        // 职业倾向得分
        inclination_list:[]

      }
    },
    components:{
      PublicAdQrcode,
      PublicTopTips,
    },
    methods: {
      reset() {
        Dialog.confirm({
          title: '重新测评',
          message: '您确认要重测吗？'
        }).then(() => {
          ceping90_reset()
            .then((data) => {
              this.$router.push("/ceping90")
            })
        }).catch(() => {
          // on cancel
        });
      },
      dimension_chart() {
        let dimension = echarts.init(document.getElementById('dimension'));
        let dimension_indicator = [];
        let dimension_value = [];
        let arry = [this.data.total_result.R,this.data.total_result.C,this.data.total_result.E,this.data.total_result.S,this.data.total_result.A,this.data.total_result.I];
        // arry.push();
        // arry.unshift(this.data.total_result.I);
        // arry.unshift(this.data.total_result.A);
        // arry.unshift(this.data.total_result.S);
        // arry.unshift(this.data.total_result.E);
        // arry.unshift(this.data.total_result.C);

        for (let attr in arry) {
          dimension_indicator.push({
            text: arry[attr].division + '. ' + arry[attr].title,
            max: 30
          });
          dimension_value.push(arry[attr].score);
        }
        let option = {
          tooltip: {
            trigger: 'axis'
          },
          radar: [{
            indicator: dimension_indicator,
            center: ['50%', '62%'],
            name: {
              textStyle: {
                color: '#E8576F',
                padding: [
                  0, // 上
                  0, // 右
                  20, // 下
                  0, // 左
                ]
              }
            },
            startAngle: 120,
            radius: 80
          }],

          series: [{
            type: 'radar',
            areaStyle: {
              normal: { //区域填充样式
                color: '#E8576F',
                opacity: '0.6'
              }
            },
            itemStyle: { //折线拐点标志的样式
              color: '#E8576F',
            },
            data: [{
              name: '得分',
              value: dimension_value,
              label: {
                normal: {
                  show: true,
                  formatter: function(params) {
                    return params.value;
                  }
                }
              }
            }]
          }]
        };

        // 为echarts对象加载数据
        dimension.setOption(option);
      },
      pullData() {
        ceping90_report()
          .then((data) => {
            if (data.code != '10002') {
              document.title = data.headtitle;
              this.body_show = true;
              this.data = data;
              // 处理职业倾向得分数据
              this.inclination_list  = getSortArr(data.total_result,'score');
              
              this.qrcode = data.qrcode;
              if (this.data.need_subscribe && !this.data.subscribe) {
                this.isShow = true;
              };
              // 给wxconfig传对象
              this.type_obj.nickname = data.nickname;
              this.type_obj.evaluation_id = data.cid;
              this.type_obj.evaluation_name = data.headtitle;
              this.type_obj.evaluation_user_id = String(data.uid);
              this.type_obj.path = this.$route.path;

              shareCon("ceping73", this, this.type_obj);
              setTimeout(() => {
                this.dimension_chart();
              }, 1000);
            } else {
              // 已经测评完成
              this.$router.push('/ceping90')
            }

          })
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss">
@import "@s/remChange.scss";
.pdt{
  margin: 30px 30px 0px;
  background-color: #ffffff;
  text-align: center;
}
.dimension_bg {
  background: url(../../../assets/dema_bg.png) no-repeat top center;
  background-size: cover;
  width: 100%;
  height: 630px;
}

.dimension {
  margin: 0 auto;
  height: 510px;
  margin: 30px auto;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  position: relative;
}

.radius {
  border-radius: 10px;
}

.pop {
  width: 8rem;
  padding-bottom: 80px;
  p:nth-child(1) {
    padding-top: 50px;
    font-size: 34px;
    line-height: 80px;
    font-weight: bold;
    color: #F57F17;
  }
  p:nth-child(2) {
    color: #333;
    font-size: 30px;
    line-height: 80px;
  }
  img {
    width: 80%;
  }
}

.cep61_top {
  width: 100%;
  background: url(../../../assets/ceping78/banner.png) no-repeat top center;
  background-size: cover;
  height: 470px;
  padding: 120px 60px 0;
  color: #333;
  position: relative;
  img.logo{
    position: absolute;
    top: 20px;
    right: 30px;
    height: 80px;
    width: auto;
  }
  h1 {
    font-size: 50px;
    font-weight: bold;
  }
  h2 {
    font-size: 26px;
    margin-top: 30px;
  }
  h3 {
    font-size: 20px;
    margin-top: 20px;
  }
  a {
    display: block;
    margin-top: 40px;
    width: 240px;
    height: 55px;
    background: rgba(232, 87, 111, 1);
    border-radius: 8px;
    font-size: 30px;
    color: #fff;
    line-height: 55px;
    text-align: center;
  }
}

.cep61_main {
  width: 690px;
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  margin: 0 auto;
  margin-top: 60px;
  padding: 70px 30px;
  h6{
    font-size: 28px;
    color: #E8576F;
    margin: 70px auto 60px;
    display: flex;
    font-weight: bold;
    div{
      border-bottom: 3px solid #E8576F;
      margin-left: 10px;
      text-align: center;
      width: 38px;
    }
  }
  .small{
    font-weight: bold;
    .stitle{
      font-size: 26px;
      color: #333333;
      margin-bottom: 80px;
    }
    .text{
      font-size: 26px;
      color: #333333;
      width: 434px;
      border-bottom: 2px solid #E8576F;
      line-height: 1;
      padding-bottom: 14px;
      text-align: center;
      margin: 0 auto;
      margin-bottom: 80px;
      &:last-child{
        margin-bottom: 50px;
      }
    }
  }
  .js div{
    font-size: 26px;
    color: #333333;
    line-height:52px;
    margin-bottom: 60px;
    display: flex;
    &:last-child{
      margin-bottom: 100px;
    }
    span.cle{
      display:block;
      width: 12px;
      height: 12px;
      background-color: #E8576F;
      border-radius: 50%;
      margin-right: 10px;
      margin-top: 20px;
    }
    span.text{
      flex: 1;
      font-size: 26px;
      color: #333333;
    }
  }
  h1 {
    font-size: 46px;
    color: #E8576F;
    text-align: center;
    font-weight: bold;
    img {
      width: 44px;
      margin: 0 50px;
    }
  }
  p.cep61_mp {
    font-size: 32px;
    line-height: 52px;
    color: #333;
    text-align: justify;
    margin-top: 80px;
    margin-bottom: 60px;
    font-weight: bold;
  }
  h2.cep61_mh2 {
    font-size: 32px;
    color: #333;
    text-align: left;
    margin-top: 70px;
    font-weight: bold;
  }
  h3.cep61_mh3 {
    font-size: 28px;
    color: #E8576F;
    text-align: left;
    margin-top: 70px;
    font-weight: bold;
  }
  h4.cep61_mh4 {
    font-size: 26px;
    color: #333;
    text-align: justify;
    margin-top: 40px;
    line-height: 50px;
  }
  .cep61_list {
    margin-top: 40px;
    ul li {
      float: left;
      margin-right: 30px;
      width: 190px;
      text-align: center;
      h2 {
        height: 118px;
        line-height: 118px;
        background: rgba(232, 87, 111, 1);
        border-radius: 8px 8px 0px 0px;
        color: #fff;
        font-size: 60px;
      }
      h3 {
        height: 118px;
        line-height: 44px;
        background: #F0F0F0;
        color: #333;
        font-size: 28px;
        padding-top: 20px;
        span {
          display: block;
          font-weight:bold;
        }
      }
    }
    ul li:last-child {
      margin-right: 0;
    }
  }
  .cep61_list1 {
    margin-top: 40px;
    ul li {
      float: left;
      margin-right: 2px;
      width: 103px;
      text-align: center;
      h2 {
        height: 60px;
        line-height: 60px;
        background: rgba(232, 87, 111, 1);
        color: #fff;
        font-size: 32px;
      }
      h3 {
        height: 60px;
        line-height: 60px;
        background: #F0F0F0;
        color: #333;
        font-size: 26px;
      }
    }
    ul li:last-child {
      margin-right: 0;
    }
  }
  .cep61_list2 {
    .inclination{
      thead tr th{
        background-color:#E8576F;
        color:#ffffff;
        font-size:28px;
        line-height:60px;
      }
      tbody tr td{
        background-color:#F0F0F0;
        color:#333333;
        font-size:26px;
        line-height:60px;
        text-align:center;
      }
    }
    .ins-text{
      margin-top:50px;
      &:nth-child(1){
        margin-top:60px;
      }
      h5{
        font-size:26px;
        color:#E8576F;
        line-height:1;
        margin-bottom:30px;
      }
      p{
        font-size:26px;
        color:#333333;
        line-height:40px;
      }
    }
  }
  .cep61_list3 {
    ul li {
      margin-top: 60px;
      position: relative;
      img {
        width: 11px;
        height: 11px;
        position: absolute;
        top: 20px;
        left: 0;
      }
      .cep61_lr {
        width: 596px;
        float: right;
        text-align: justify;
        color: #333;
        font-size: 26px;
        line-height: 50px;
      }
    }
  }
  .cep61_list4 {
    ul li {
      h2 {
        color: #333;
        font-size: 26px;
        font-weight: bold;
      }
      h3 {
        font-size: 26px;
      }
    }
  }
  .cep61_bt {
    margin-top: 65px;
    h2 {
      width: 630px;
      height: 30px;
      background: rgba(232, 87, 111, 1);
      border-radius: 15px 15px 0px 0px;
    }
    .cep61_btv {
      padding: 26px;
      line-height: 50px;
      font-size: 26px;
      color: #333;
      text-align: justify;
      background-color: #FEF6F8;
    }
  }
  .cep61_list5 {
    ul li {
      margin: 0 auto;
      margin-top: 60px;
      width: 440px;
      border-bottom: 2px solid #E8576F;
      padding-bottom: 14px;
      text-align: center;
      font-size: 26px;
      color: #333;
      font-weight: bold;
    }
  }
}
.copynig{
  font-size: 24px;
  color: #999999;
  padding: 50px 32px 60px;
}
</style>
